<!-- 采购历史 -->
<template>
    <cc-container class="purchase-history">
      <cc-header-nav>
        <template slot="right">
          <cc-svg-icon @click="showDate" icon-class="date" />
        </template>
        <template slot="center">
          <div @click="isShowState = !isShowState">{{selectedText}}<cc-svg-icon :class-name="isShowState ? 'icon-down':'icon-up'" icon-class="left-arrow" /></div>
        </template>
      </cc-header-nav>
      <cc-main>
        <cc-fade>
          <cc-date-filter v-show="dateFilterVisible" @search="handleDateFilter">
          </cc-date-filter>
        </cc-fade>
      <div class="search-box">
        <input v-model.trim="params.plan_order_number" class="input-search" type="text" placeholder="计划单号">
        <cc-svg-icon @click="toSearch" size='.16rem' class-name='search-icon' icon-class='search'></cc-svg-icon>
      </div>
      <skeleton v-if="showSkeleton"/>
      <van-list
        v-else
        class="purchase-history-list"
        v-model="m_loading"
        :finished="m_finished"
        :finished-text="m_finishedText"
        @load="mHandlePullUpLoadMore"
        :immediate-check="m_immediateCheck"
      >
        <cc-not-order 
          v-if="list.length === 0 && m_loading === false" 
          tip="亲，暂无相关采购计划单哦"
          :is-router="true"
          url="/purchase/product-stocks"
        >
        </cc-not-order>
        <cc-animation-list>
          <purchase-history-item class="purchase-history-item"
            v-for="item in list"
            :key="item.id"
            :item="item"
          >
          </purchase-history-item>
        </cc-animation-list>
      </van-list>
      <div class="select-state-btns" v-show="isShowState">
        <span v-for="(item,index) in state" @click="changeStete(index,item.id)"  :class="{active: item.selected}" :key="index">{{item.text}}</span>
      </div>
      <div class="select-state-model" @click="isShowState = false" v-show="isShowState"> </div>
      </cc-main>
      <cc-footer>
        <cc-nav></cc-nav>
      </cc-footer>
     </cc-container>
</template>

<script>
import PurchaseHistoryItem from './item.vue'
import Skeleton from './skeleton.vue'
import Vue from 'vue'
import { Lazyload, Icon, Search, List, Button } from 'vant'
import { loadPurchaseHistoryList } from '~fetch/manage-center/purchase'
import ListMixin from '@/mixins/list'
Vue.use(Icon)
  .use(Search)
  .use(List)
  .use(Lazyload)
  .use(Button)
export default {
  mixins: [ ListMixin ],
  components: {
    PurchaseHistoryItem,
    Skeleton
  },

  data () {
    return {
      showSkeleton: true,
      selectedText: '全部',
      state: [
        {
          id: '',
          text: '全部',
          selected: true
        },
        {
          id: 0,
          text: '待审核',
          selected: false
        },
        {
          id: 1,
          text: '已审核',
          selected: false
        },
        {
          id: 2,
          text: '已拒绝',
          selected: false
        },
        {
          id: 3,
          text: '已取消',
          selected: false
        }
      ],
      dateFilterVisible: false,
      isShowState: false, // 状态model
      start_time: null,
      end_time: null,
      list: [
      ],
      params: {
        start_date: '',
        end_date: '',
        plan_order_number: '',
        state: ''
      }
    }
  },

  computed: {},

  created () {
    this.loadData()
  },
  mounted () {
  },

  methods: {
    /**
     * @description 采购订单号搜索
     */
    toSearch () {
      this.search()
    },
    search () {
      this.mReset()
      const reset = true
      this.loadData(reset)
    },
    /**
     * @description 加载数据
     */
    async loadData (reset) {
      if (reset) {
          this.list = []
        }
      this.mRequest()
      const params = this.params
      params.page = this.m_page.curr
      params.limit = this.m_page.limit
      let res = await loadPurchaseHistoryList(params)
      this.$tips(res, {
        tip: false
      }, res => {
        this.showSkeleton = false
        const data = res
        if (data.list.length === 0) {
          this.mEnd()
          if (this.list.length === 0) {
            this.m_finishedText = ''
          }
        } else {
          let list = data.list.map(item => {
            let arr = []
            item.planOrderGoods.length > 0 && item.planOrderGoods.forEach(prop => {
              let newArr = (prop.image_list.length > 0 && [prop.image_list[0]]) || []
              arr = [...arr, ...newArr]
            })
            return {
              id: item.id,
              plan_order_number: item.plan_order_number,
              state: item.state,
              total_price: item.total_price,
              goods_num: item.planOrderGoods.reduce((total, next) => {
                return total + parseInt(next.quantity)
              }, 0),
              goods_img: arr.length > 0 ? arr : [this.$notImg]
            }
          })
          this.list = [...this.list, ...list]
        }
      })
      this.mSuccess()
    },
    /**
     * @description 时间筛选
     */
    handleDateFilter ({ startDate, endDate }) {
      this.params.start_date = startDate
      this.params.end_date = endDate
      this.search()
      // this.dateFilterVisible = false
    },
    /**
     * @description 打开时间组件
     */
    showDate () {
      this.isShowState = false
      this.dateFilterVisible = !this.dateFilterVisible
    },
    /**
     * @description 选择状态
     */
    changeStete (index, id) {
      this.state.forEach(item => {
        item.selected = false
      })
      this.selectedText = this.state[index].text
      this.state[index].selected = true
      this.isShowState = false
      this.params.state = id
      this.search()
    }
  }
}

</script>
<style lang='scss' scoped>
.purchase-history {
  /deep/{
    .van-icon-plus{
      bottom: -3px;
    }
  }
}
@import '~styles/index.scss';
.search-box{
    border-bottom: 1px solid $border-color-base;
}
.purchase-history {
  @include flex;
  &-item{
   background: #fff;
  }
  .search-box {
    height: 40px;
    position: relative;
    background: #fff;
    @include center(column);
    .input-search {
      height: 28px;
      width: 92%;
      border-radius: 2px;
      border: 1px solid $border-color-base;
      padding-left: 10px;
      font-size: 12px;
      box-sizing: border-box;
    }
    .search-icon {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: 20px;
    }
  }
  .purchase-history  {
    &-list {
      @include flex(column);
    }
  }
}
.icon-down{
  transform: rotate(-90deg) translate(2px,2px);
}
.icon-up{
  transform: rotate(90deg) translate(-2px,-2px);
}
.select-state-btns{
  width: 100%;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #f3f4f6;
  height: auto;
  position: fixed;
  top: 45px;
  z-index: 11;
  width: 100%;
  border-bottom: 1px solid #e5e5e5;
  padding-bottom: 10px;
  animation: selectMove 0.5s;
  transition: all;
  span{
    display: inline-block;
    height: 30px;
    width: 20%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    background: #fff;
    border: 1px solid #e5e5e5;
    margin:10px 2.2% 0;
  }
  .active{
    color: #ff8c00;
    border: #ff8c00 1px solid;
  }

}
@keyframes selectMove
{
    from {top: -80px;}
    to {top: 45px;}
}
.select-state-model{
  width: 100%;
  height: calc(100vh - 45px);
  position: fixed;
  top: 45px;
  z-index: 10;
  background-color: rgba(0, 0, 0, 0.5);

}
</style>
